<template>
  <div class="payment-pix-success">
    <div class="timer">
      <AmIconMaterial
        :class="['timer__watch', setColorFinishTimer]"
        name="timer"
        type="outlined"
        size="lg"
      />
      <AmTypography
        :class="['timer__text', setColorFinishTimer]"
        :text="textExpiresPixCode"
        typography-style="l3"
        weight="bold"
      />
      <AmTypography
        :class="['timer__temp', setColorFinishTimer]"
        :text="`${timer}`"
        typography-style="l3"
        weight="bold"
      />
    </div>
    <AmTypography
      class="instructions"
      text="Escaneie ou cole o código no aplicativo do seu banco para efetuar o pagamento."
      typography-style="l3"
    />

    <div class="qr-code">
      <img
        v-if="checkCountDownTimer"
        width="210"
        :src="`data:image/jgp;base64,${pix.pix_qrcode}`"
        alt="qrcode"
      />
      <div
        v-else-if="!checkCountDownTimer && !enabledTryAgainPayment"
        class="qr-code__refresh"
        @click="refreshCodePix()"
      >
        <AmIconMaterial
          class="qr-code__refresh__icon"
          name="refresh"
          size="xl"
        />
        <AmTypography
          class="qr-code__refresh__text"
          text="Gerar novo código para prosseguir o pagamento"
          typography-style="l6"
          weight="bold"
        />
      </div>
      <div
        v-else-if="!checkCountDownTimer && enabledTryAgainPayment"
        class="qr-code__refresh"
      >
        <AmIconMaterial
          class="qr-code__refresh__icon"
          name="refresh"
          size="xl"
        />
        <AmTypography
          class="qr-code__refresh__text"
          text="Aguarde seu pix está sendo gerado"
          typography-style="l6"
          weight="bold"
        />
      </div>
    </div>

    <input
      id="pixCode"
      :value="pix.pix_emv"
      type="text"
      readonly
    />

    <AmTypography
      class="price"
      typography-style="l3"
      weight="bold"
    >
      <template>
        <div>Valor {{ pix.value | currencyBRL }}</div>
      </template>
    </AmTypography>

    <AmButton
      :class="['copy', theme.color]"
      :label="pixActionLabel"
      color="blue"
      size="xl"
      :disabled="enabledTryAgainPayment"
      full-width
      :icon="iconPayment"
      @click="pixAction"
    >
      <template
        v-if="loadingGlobal"
        #content
      >
        <AmLoading
          class="loading--white"
          :AmLoaderSize="35"
        />
      </template>
    </AmButton>
  </div>
</template>

<script>
import moment from 'moment'
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import copyTextClipboard from '@/utils/copyTextToClipboard'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { injectPixelScript } from '@/utils/pixels/injectPixelScript'
import { pixelPurchaseParams } from '@/utils/pixels/pixelPurchaseParams'
import pixPaymentSuccessNotification from '@/utils/pixPaymentSuccess'

export default {
  name: 'PaymentPixSuccess',
  mixins: [themeMixin, currencyFilterMixin],
  data() {
    return {
      value: {},
      enabledTryAgainPayment: true,
      timer: '00:00:00',
      pixAction: () => {},
      pixActionLabel: 'Copiar código do Pix',
      textExpiresPixCode: 'Seu código expira em',
      iconPayment: {
        name: '',
        position: 'left',
        type: 'material',
        size: 'xl',
      },
      timerFinish: true,
      timerInterval: null,
    }
  },
  computed: {
    ...mapGetters('Customer', ['getDocumentNumber']),
    pix: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    checkCountDownTimer() {
      return this.timerFinish
    },
    setColorFinishTimer() {
      if (!this.checkCountDownTimer) {
        this.paymentForPixFinishTimer()
        return 'timer--finish'
      }

      return false
    },
    ...mapState('Checkout', {
      cart: (state) => state.cart,
      pixels: (state) => state.pixels,
      loadingGlobal: (state) => state.globalLoading,
    }),
    ...mapGetters('Checkout', {
      paymentPix: 'getPaymentPix',
    }),
  },
  watch: {
    paymentPix: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.value = newValue
        }
      },
    },
    loadingGlobal: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.enabledTryAgainPayment = true
          return newValue
        }

        this.enabledTryAgainPayment = false
        return newValue
      },
    },
    timer() {
      this.statusTimer()
    },
    pix: {
      handler() {
        this.initTimer()
      },
      deep: true,
    },
  },
  created() {
    this.initTimer()
  },
  beforeMount() {
    if (this.cart.order_id) {
      sessionStorage.setItem('channelReference', window.btoa(this.cart.order_id))
    }
  },
  mounted() {
    this.loadCheckoutPixel()
    this.loadPixPaymentSuccess()
    this.SET_CURRENT_STEP(10)
  },
  methods: {
    ...mapMutations('Checkout', ['SET_CURRENT_STEP']),
    ...mapActions('Checkout', {
      refreshPix: 'paymentPix',
    }),
    statusTimer() {
      const codeTimer = this.codeTimerForPix()
      const actionSelect = codeTimer ? 1 : 0

      const pixActions = {
        1: () => this.copyTransferArea(),
        0: () => this.refreshCodePix(),
      }

      const pixActionLabel = {
        1: 'Copiar código do Pix',
        0: 'Gerar novo código Pix',
      }

      this.pixAction = pixActions[actionSelect] || pixActions[1]
      this.pixActionLabel = pixActionLabel[actionSelect] || pixActionLabel[1]

      if (!codeTimer) {
        this.iconPayment.name = 'pix'
        this.textExpiresPixCode = 'Seu código expirou!'
      } else {
        this.iconPayment.name = ''
        this.textExpiresPixCode = 'Seu código expira em'
      }
    },
    codeTimerForPix() {
      return this.timerFinish
    },
    copyTransferArea() {
      copyTextClipboard('#pixCode')

      this.$AmAlert({
        type: 'success',
        description: 'Código copiado',
        autoHide: true,
      })
    },
    async refreshCodePix() {
      this.$AmAlert({
        type: 'warning',
        description: 'Aguarde seu pix está sendo gerado',
        autoHide: true,
      })
      await this.requestNewPixCode()
    },
    async requestNewPixCode() {
      try {
        await this.refreshPix({ document: this.getDocumentNumber })
        this.$AmAlert({
          type: 'success',
          description: 'Pix gerado com sucesso',
          autoHide: true,
        })
        this.$emit('refreshCodePix')
        const pixLocalStorage = JSON.parse(localStorage.getItem('paymentPix'))
        this.pix = pixLocalStorage
        this.value = pixLocalStorage
      } catch (error) {
        this.$AmAlert({
          type: 'error',
          description: 'Erro ao gerar o pix. Tente novamente',
          autoHide: true,
        })
      }
    },
    initTimer() {
      const currentTime = moment().unix()
      const eventTime = moment(this.value.pix_expiration_date).unix()
      const diffTime = eventTime - currentTime
      let duration = moment.duration(diffTime * 1000, 'milliseconds')
      const interval = 1000

      const timerProgress = () => {
        duration = moment.duration(duration - interval, 'milliseconds')
        const currentDiff = duration - interval
        if (currentDiff > 0) {
          this.timer = `${this.strPadTimer(duration.hours())}:${this.strPadTimer(
            duration.minutes()
          )}:${this.strPadTimer(duration.seconds())}`
          this.timerFinish = true
        } else {
          this.timer = '00:00:00'
          this.timerFinish = false
          this.statusTimer()
          clearInterval(this.timerInterval)
          this.timerInterval = null
        }
      }

      this.timerInterval = setInterval(() => timerProgress(), interval)
    },
    strPadTimer(strPad) {
      return strPad.toString().padStart(2, '0')
    },
    paymentForPixFinishTimer() {
      this.$emit('paymentForPixFinishTimer')
    },
    loadCheckoutPixel() {
      try {
        const pixels = pixelPurchaseParams(this.pixels, this.cart, 'pix_order')

        if (pixels.length) {
          injectPixelScript(pixels, 'purchase')
        }
      } catch (error) {
        throw new Error(error)
      }
    },

    loadPixPaymentSuccess() {
      pixPaymentSuccessNotification.setup()
      pixPaymentSuccessNotification.setChannel(
        `${process.env.VUE_APP_PUSHER_CHANNEL_PREFIX.replace(/"/g, '')}${atob(
          sessionStorage.getItem('channelReference')
        )}`
      )
      pixPaymentSuccessNotification.channel.bind(
        process.env.VUE_APP_PUSHER_EVENT_NAME.replace(/"/g, ''),
        () => {
          this.$router.push({ name: 'new.stepPaymentPixConfirmed' })
          sessionStorage.removeItem('channelReference')
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-pix-success {
  display: flex;
  flex-direction: column;
  width: 100%;

  .timer {
    display: flex;
    align-items: center;
    justify-content: center;

    &__watch {
      margin-right: 11px;
      color: $dark;
    }

    &__temp {
      margin-left: 5px;
    }
  }

  .timer--finish {
    &,
    ::v-deep div {
      color: $error;
    }
  }

  .instructions {
    width: 70%;
    text-align: center;
    margin: 20px auto auto;
  }

  .qr-code {
    margin: 16px auto 0 auto;

    &__refresh {
      cursor: pointer;
      background: rgba($dark, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      width: 173px;
      border-radius: 8px;
      text-align: center;
      padding: 10px;

      &__icon {
        font-size: 5em !important;
        color: rgba($dark, 0.8);
        margin-bottom: 15px;
      }

      &__text {
        margin-bottom: 29px;
      }
    }
  }

  .price {
    margin: {
      top: 16px;
      bottom: 36px;
    }
    text-align: center;
  }

  .copy {
    margin-top: 38px;
  }

  #pixCode {
    display: none;
  }
}
</style>
